import axios from 'axios';

class Backend {
	getSettings = config => {
		var axiosConfig = {
			method: 'POST',
			url: `${config.url}hammurabi-tools/settings`,
			data: {
				'X-Hammurabikey': 'hammurabi-app-2022',
			},
		};

		return new Promise((resolve, reject) => {
			axios(axiosConfig)
				.then(response => {
					resolve(response.data);
				})
				.catch(e => {
					reject(e);
				});
		});
	};
	saveSettings = (config, newSettings) => {
		var data = { ...newSettings, 'X-Hammurabi-Key': 'hammurabi-app-2022' };

		var axiosConfig = {
			method: 'put',
			url: `${config.url}hammurabi-tools/settings`,
			data: data,
		};

		return new Promise((resolve, reject) => {
			axios(axiosConfig)
				.then(response => resolve(response))
				.catch(e => reject(e));
		});
	};
}

const instance = new Backend();

export default instance;
